/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { ConstructionActionBase } from "../../../../schema/generated/ConstructionAction";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class ConstructionActionDataApi extends EntityDataApi<ConstructionActionBase> {
  public readonly def = idbEntityDefs.ConstructionAction;
}